import {getSymplouGenerativeModel} from "./firebase-ai";

/**
 * Retorna até 3 sugestões de nome com base no prefixo digitado.
 */
export async function suggestProductNames(partialName: string): Promise<string[]> {
  const raw = partialName.trim();
  if (raw.length < 2) return [];

  const model = getSymplouGenerativeModel();
  const prompt = `Você ajuda a nomear produtos de varejo no Brasil (português).
O usuário está digitando este prefixo ou nome parcial: "${raw}".

Responda com exatamente 3 linhas. Em cada linha, um nome completo de produto (curto e claro).
Sem numeração, sem aspas, sem markdown, sem texto extra.`;

  const result = await model.generateContent(prompt);
  const text = result.response.text().trim();
  const lines = text
    .split("\n")
    .map((l) =>
      l
        .replace(/^\d+[).\s-]+/, "")
        .replace(/^[-*]\s*/, "")
        .trim()
    )
    .filter(Boolean);

  const uniq = Array.from(new Set(lines));
  return uniq.slice(0, 3);
}
